import actionTypes from 'src/modules/redux/actionTypes'

export const setFavouriteProfiles = (profiles, count, type) => ({
  type: actionTypes.SET_FAVOURITE_PROFILES,
  payload: {profiles, count, type}
})
